
namespace TabAurous.Reports {


    export class ProductSalesOptions {
        items: TabAurous.Sales.SalesItemsRow[];
    }

    export class ProductSalesPanel extends Serenity.TemplatedPanel<CustomerSalesOptions> {
        constructor(container: JQuery, opt: CustomerSalesOptions) {
            super(container, opt);

            //Grouping
            var data = this.options.items;
            var code = [""];
            var grossamount = [0];
            code.pop();
            grossamount.pop();
            for (var i = 0; i < data.length; i++) {
                var checkexists = false;
                for (var j = 0; j < code.length; j++) {
                    if (data[i].ProductName.match(code[j])) {
                        checkexists = true;
                        grossamount[j] += data[i].GrossAmount;
                        grossamount[j] = parseFloat(grossamount[j].toFixed(2));
                    }
                }
                if (!checkexists) {
                    code.push(data[i].ProductName);
                    grossamount.push(parseFloat(data[i].GrossAmount.toFixed(2)));
                }
            }
            var options = {
                chart: {
                    height: 250,
                    width: 430,
                    type: 'line',
                    fontFamily: '"PT Sans", sans-serif',
                    zoom: {
                        enabled: false
                    }
                },
                series: [
                    {
                        name: 'sales',
                        data: grossamount
                    }
                ],

                stroke: {
                    curve: 'straight'
                },
                xaxis: {
                    categories: code
                }
            }
            var x = document.getElementById('TabAurous_Reports_ProductSalesPanel14_chartContainer');
            var chart = new ApexCharts(x, options);

            chart.render();
        }

        getTemplate() {

            return `<div id="~_chartContainer"></div>`;
        }
    }

    @Serenity.Decorators.registerClass()
    export class ProductSalesItemsGrid extends Serenity.EntityGrid<TabAurous.Sales.SalesItemsRow, any> {
        protected getColumnsKey() { return 'Sales.CustomerSalesItems'; }
        protected getDialogType() { return TabAurous.Sales.SalesItemsDialog; }
        protected getIdProperty() { return TabAurous.Sales.SalesItemsRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Sales.SalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Sales.SalesItemsRow.localTextPrefix; }
        protected getService() { return TabAurous.Sales.ProductSalesItemsService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: ProductSalesPanel;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");

            this.addDateRangeFilter("TransDate", "Date");
            this.addQuickFilter({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: OMS.CompanyRow.lookupKey,
                    multiple: true

                },
                field: 'CompanyId',
                title: 'Company',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        companyids = temp;
                    }
                    w.active = false;
                    w.handled = true;
                    return false;
                },

                cssClass: 'hidden-xs'

            });

            //this.addDateRangeFilter("TransDate", "Date");
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();

            grid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            this.view.setSummaryOptions({
                aggregators: [
                    new Slick.Aggregators.Sum('GrossAmount'),
                    new Slick.Aggregators.Sum('NetAmount')
                ]
            });


            return grid;
        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }
        //protected getColumns() {
        //    var columns = super.getColumns();

        //    Q.first(columns, x => x.field === 'GrossAmount')
        //        .groupTotalsFormatter = (totals, col) =>
        //            (totals.sum ? (Q.coalesce(totals.sum[col.field], '')) : '');

        //    return columns;
        //}
        protected getQuickFilters() {
            var filters = super.getQuickFilters();


            return filters;
        }
        onViewProcessData(response: Serenity.ListResponse<TabAurous.Sales.SalesItemsRow>) {

            if (!this.chartContainer) {
                this.chartContainer = $("<div style='padding: 20px 0' />");
                this.chartContainer.insertBefore(this.element.find(".grid-container"));
            }

            if (this.chartPanel) {
                this.chartPanel.destroy();
            }

            this.chartPanel = new ProductSalesPanel(this.chartContainer, { items: response.Entities });

            var options = {
                chart: {
                    type: 'bar'
                },
                series: [
                    {
                        name: 'sales',
                        data: [30, 40, 35, 50, 49, 60, 70, 91, 125]
                    }
                ],
                xaxis: {
                    categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
                }
            }

            var chart = new ApexCharts(document.querySelector(".chartContainer"), options);

            chart.render();


            return response;
        }

        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                    title: 'Apply Filter',
                    cssClass: '',
                    icon: 'fa-filter',
                    onClick: () => {
                        applyfilter = true;
                        if (companyids.length != 0) {
                            (this.view.params as ReportFiltersRequest).CompanyIds = companyids;

                        } if (finid.length != 0) {
                            (this.view.params as ReportFiltersRequest).FinancialYearIds = finid;
                        } if (vendorids.length != 0) {
                            (this.view.params as ReportFiltersRequest).VendorIds = vendorids;
                        }
                        var request: ReportFiltersRequest = {
                            VendorIds: vendorids,
                            CompanyIds: companyids,
                            FinancialYearIds: finid,
                            BaseItemTypeIds: baseitemid,
                            CategoryIds: typeids,
                            SubCategoryIds: subtypeids
                        }
                        Sales.ProductSalesItemsService.List(request, response => {
                            this.setItems(response.Entities);
                            //this.refresh();
                        }, { async: false, blockUI: true });


                    }

            });
            return buttons;
        }
    }
}